import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-mediego-exit-no-save-confirmation-dialog',
    templateUrl: './exit-no-save-confirmation-dialog.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExitNoSaveConfirmationDialogComponent {}
